import { BrandLogo } from '@/components/shared/BrandLogo';
import { ThemeToggle } from '@/components/shared/ThemeToggle';
import { useSessionStore } from '@/store/session-store';
import { PortalNav } from './PortalNav';
import { SessionControls } from './SessionControls';

/**
 * Branded header of the shell: logo and enlarged wordmark on the top row, tabs and session controls
 * together on the row below. Both keep their slot for an anonymous visitor: the controls render the
 * Sign in link, and the tabs narrow to the screens that are open without a session. Reads the session store directly, like SessionControls, so the two rows
 * can never disagree about the signed-in state.
 */
export function PortalHeader(): React.JSX.Element {
  const providerId = useSessionStore((state) => state.providerId);

  return (
    <header className="border-line border-b bg-surface px-6 pt-5 sm:px-10">
      <div className="mx-auto flex max-w-shell flex-wrap items-center justify-between gap-4">
        <BrandLogo className="h-12 sm:h-20" />
        <p className="text-brand-600 border-gold-500 border-b-[3px] pb-1.5 text-lg font-semibold tracking-[0.18em] sm:text-[27px]">
          PROVIDER PORTAL
        </p>
      </div>

      <div className="mx-auto flex max-w-shell flex-wrap items-center gap-4 py-4">
        <PortalNav signedIn={providerId !== null} />
        <div className="ml-auto flex items-center gap-3">
          <ThemeToggle />
          <SessionControls />
        </div>
      </div>
    </header>
  );
}
